var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconBirthday = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("g", { transform: "translate(-1.083 -1.083)" },
                React.createElement("path", { d: "M24.8,16.1v10.8H7.4V16.1" }),
                React.createElement("path", { d: "M5.3,10.7h21.7v5.4H5.3V10.7z" }),
                React.createElement("path", { d: "M16.1,26.9V10.7" }),
                React.createElement("path", { d: "M16.1,10.7h-4.9c-1.5,0-2.7-1.2-2.7-2.7s1.2-2.7,2.7-2.7C15,5.3,16.1,10.7,16.1,10.7z" }),
                React.createElement("path", { d: "M16.1,10.7H21c1.5,0,2.7-1.2,2.7-2.7S22.5,5.2,21,5.2C17.2,5.3,16.1,10.7,16.1,10.7z" })))));
});
export default IconBirthday;
//# sourceMappingURL=IconBirthday.js.map